package org.example.zone360.pages.coachDetails.coachInfo

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.stevdza.san.kotlinbs.components.BSTooltip
import com.stevdza.san.kotlinbs.components.initializeTooltips
import com.stevdza.san.kotlinbs.models.TooltipDirection
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaInfo
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import kotlinx.browser.window
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CoachHeaderSessions(
    image: String,
    title: String,
    data: String,
    sitePalette: SitePalette,
    toolTipText : String = ""
){
    Row(
        modifier = Modifier
            .width(if(window.screen.width > 800 )33.percent else if(window.screen.width in 600..799)49.percent else 100.percent)
            .margin(topBottom = 10.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .width(36.px)
                .height(36.px)
                .margin(right = 10.px),
            contentAlignment = Alignment.Center
        ) {
            // Background layer with 20% opacity
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .backgroundImage(
                        linearGradient(
                            LinearGradient.Direction.ToBottomRight,
                            sitePalette.coachHeaderGradientOne.rgb,
                            sitePalette.coachHeaderGradientTwo.rgb
                        )
                    )
                    .borderRadius(100.px)
                    .opacity(0.2) // ✅ Opacity only applied to background
            )
            Image(src = image, modifier = Modifier.width(20.px).height(20.px))
        }

        Column {
            Row(
                verticalAlignment = Alignment.CenterVertically
            ) {
                FieldTitleTextNormalSimple(
                    title,
                    fontSize = 14.px
                )
                LaunchedEffect(Unit) {
                    initializeTooltips()

                }

                BSTooltip(
                    text = toolTipText,
                    direction = TooltipDirection.Top,
                    content = {
                        Box(
                            modifier = Modifier
                                .width(15.px)
                                .height(15.px)
                                .cursor(Cursor.Pointer)
                                .backgroundColor(Colors.LightGray)
                                .borderRadius(100.px)
                                .margin(left = 10.px),
                            contentAlignment = Alignment.Center
                        ) {
                            FaInfo(
                                modifier = Modifier.color(Colors.White).cursor(Cursor.Pointer)
                                    .onClick {  },
                                size = IconSize.XXS
                            )
                        }
                    })
            } to
                    FieldTitleTextNormalSimple(
                        data,
                        fontWeight = 600,
                        marginTop = 6.px,
                        fontSize = 16.px
                    )

        }
    }
}